<template>
  <div class="app-main-content bill-overseas-s-center-view">
    <div
      class="main-content"
      type="primary"
    >
      <customs-file-search-condition
        ref="queryBillActualAmountCondition"
        @advSearchItemResetCallBack="toQuery"
        @add="addEventHandler"
        @edit="editEventHandler"
        @batchSave="batchSaveHandler"
        @backList="backListEventHandler"
        @gather="gatherEventHandler"
        @print="printEventHandler"
        @batchState="batchStateEventHandler"
        @clearData="clearDataHandler"
        @backState="backStateHandler"
        @unFrozen="xhqCustomsUnFrozenHandler"
        @openChatPage="xhqOpenChatPage"
      />
    </div>
    <customs-file-grid
      config-module="20220113"
      :row-data="rowData"
      :grid-options="gridOptions"
      @batchSaveHandler="customsNoUpdateHandler"
    />
    <div class="pagination-wrapper">
      <div v-if="appendQuery" class="pagination-container">
        <el-pagination
          style="text-align: left;"
          :total="rowData.length"
          layout="total"
        />
      </div>
      <cargo-pagination
        v-else
        config-module="20220113"
        :total="total"
        :page.sync="pageNum"
        :limit.sync="pageSize"
        @pagination="toQuery()"
      />
    </div>
    <!-- 新增弹框 -->
    <customs-info-dialog ref="customsInfoDialog" :visible.sync="addDialog.visible" :selected-customs-info="selectedCustomsInfo" :job="job" @successHandler="successHandler" />

    <!-- 文件编辑弹框 -->
    <edit-customs-file ref="fileDialog" :visible.sync="editDialog.visible" :selected-file="selectedFile" :job="job" @successHandler="successHandler" />

    <!-- 退单列表 -->
    <back-list-window
      ref="dcReturn"
      :row-list="backList.rowList"
      :visible="backList.visible"
      @visibleHandler="visibleHandler"
    />
    <!--   收款信息 -->
    <collect-info-window
      ref="dcReturn"
      :row-list="collectInfo.rowList"
      :visible="collectInfo.visible"
      @visibleHandler="visibleHandler"
    />
    <!-- 打印报表对话框 -->
    <cargo-template-selector-dialog
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.cxt"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
    />
    <!-- 送出 -->
    <dc-send-out-window
      ref="dcSendOut"
      :send-out-dialog="sendOutDialog"
      :visible="sendOutDialog.visible"
      :job="job"
      :selected-files="selectedRows"
      @dcSendOutVisible="sendOutDialog.visible=false"
      @successHandler="successHandler"
    />

    <batch-state-window
      :visible="batchStateWindow.visible"
      :label-name="batchStateWindow.labelName"
      :title="batchStateWindow.title"
      :files="batchStateWindow.files"
      :select-date="batchStateWindow.selectDate"
      :file-state="batchStateWindow.fileState"
      @closePage="visibleHandler"
      @successHandler="batchStateSuccessHandler"
    />

    <rollback-window
      :visible="rollbackWindow.visible"
      :files="rollbackWindow.files"
      @closePage="visibleHandler"
      @successHandler="batchStateSuccessHandler"
    />
  </div>
</template>

<script>
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'
import CustomsInfoDialog from '@/components/Cargo/Job/customsInfoDialog'
import CustomsFileSearchCondition from '@/views/cargo/v0/SeaExport/CustomsFile/components/customsFileSearchCondition'
import CustomsFileGrid from '@/views/cargo/v0/SeaExport/CustomsFile/components/customsFileGrid'
import { queryJobNoLinkFunc } from '@/api/booking/job'
import CollectInfoWindow from '@/views/cargo/v0/Clearing/components/DocumentCirculation/collectInfoWindow'
import BackListWindow from '@/views/cargo/v0/Clearing/components/DocumentCirculation/backListWindow'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import {
  getFileByCustomerIdHandler,
  getInvoiceByJobHandler,
  queryCustomsManageFunc,
  updateFileFunc,
  querySeCustomsFile
} from '@/api/seaExport/file'
import editCustomsFile from '@/components/Cargo/Job/editCustomsFile'
import { getObjectByCache } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { Company } from '@/class/model/mdm/Company'
import dcSendOutWindow from '@/views/cargo/v0/Clearing/components/DocumentCirculation/dcSendOutWindow'
import { YGD_TYPE, YJD_TYPE, YQH_TYPE, YTH_TYPE, YTS_TYPE } from '@/class/cargo/model/parameters/FileState'
import BatchStateWindow from '@/views/cargo/v0/SeaExport/CustomsFile/components/batchStateWindow'
import RollbackWindow from '@/views/cargo/v0/SeaExport/CustomsFile/components/rollbackWindow'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor'
import { xhqCustomsUnFrozen, xhqJumpChatPage } from '@/api/seaExport/customsInfo'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { cache, cacheName } from '@/utils/cacheManager'
import * as XhqCustomState from '@/class/cargo/model/parameters/XhqCustomState'

export default {
  name: 'CustomsFile',
  components: {
    RollbackWindow,
    BatchStateWindow,
    editCustomsFile,
    CustomsFileGrid,
    CustomsInfoDialog,
    dcSendOutWindow,
    CustomsFileSearchCondition,
    cargoTemplateSelectorDialog,
    CollectInfoWindow,
    BackListWindow
  },
  data() {
    return {
      fullscreenLoading: null,
      rowData: [],
      numAll: 100,
      numSelected: 0,
      sumCredit: '',
      sumDebit: '',
      selectedRows: [],
      selectRow: null,
      selectedFile: {},
      job: {},
      selectedCustomsInfo: {},
      addDialog: {
        visible: false
      },
      editDialog: {
        visible: false
      },
      backList: {
        rowList: [],
        visible: false
      },
      collectInfo: {
        rowList: [],
        visible: false
      },
      rollbackWindow: {
        visible: false,
        files: []
      },
      sendOutDialog: {
        visible: false,
        sendType: 1,
        customerType: 1,
        printFlag: false,
        formData: {
          receiveCompany: '',
          receivePerson: '',
          receiveAddress: '',
          receiveTel: '',
          expressNo: ''
        }
      },
      customsNoList: [],
      batchStateWindow: {
        visible: false,
        fileState: 0,
        labelName: '',
        title: '',
        selectDate: new Date(),
        files: []
      },
      // 模板选择弹窗
      templateSelectorDialog: {
        visible: false,
        cxt: new SeaExportJob(),
        category: 'FileList',
        data: {}
      },
      gridApi: null,
      isFirstNewFile: false,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        // 添加编辑组件
        frameworkComponents: {
          CargoAgGridCommonInputEditor
        },
        onRowClicked: this.onGridRowClickedEvent,
        onSelectionChanged: (event) => {
          this.selectedRows = event.api.getSelectedRows()
        },
        // 选中 勾选框或者其他列 都会触发
        onCellFocused: (event) => {
          this.onGridCellFocused(event)
        }
      },
      openXHQDocumentCenter: '',
      filter: {
        conditions: [],
        branchId: 0
      },
      pageNum: 1,
      pageSize: 100,
      total: 0,
      appendQuery: false
    }
  },
  created() {
    cache.load(cacheName.CONFIG)
    this.openXHQDocumentCenter = cache.config.get('OpenXHQDocumentCenter')
  },
  methods: {
    toQuery(data) {
      // const option = this.$refs['queryBillActualAmountCondition'].filter
      // if (option.isMerge && !option.hasOwnProperty('accountId')) {
      //   this.$message.warning(this.$t('CargoMsg.Cargo_PleaseEnterCorrectBillingParty'))
      //   return
      // }
      // option.branchId = this.$store.getters.currentOfficeId
      // option['limit'] = option.pageSize
      // this.fullscreenLoading = getLoading()
      // queryCustomsManageFunc(option, { queryType: this.queryType(option) }).then(res => {
      //   this.queryHandler(res)
      //   this.loadingEnd()
      // }).catch((err) => {
      //   this.$message.error(err)
      //   this.fullscreenLoading.close()
      // })
      const filter = this.filter
      if (typeof data !== 'undefined') {
        // 获取追加查询条件
        this.appendQuery = false
        for (let i = 0; i < data.length; ++i) {
          if (data[i].appendQuery !== undefined) {
            this.appendQuery = data[i].appendQuery
            data.splice(i, 1)
            break
          }
        }
        filter.conditions = data
        this.pageNum = 1
      }
      filter.branchId = this.$store.getters.currentOfficeId
      filter.pageNum = this.pageNum
      filter.pageSize = this.pageSize
      filter.appendQuery = this.appendQuery
      const loading = getLoading4Cxt(this)
      querySeCustomsFile(filter).then(res => {
        const list = res.data.list
        for (let i = 0; i < list.length; ++i) {
          const item = list[i]
          if (item.uuid) {
            item.jobNo = item.jobNo || item.jobNo2
            item.op = item.jobOp
            item.sales = item.jobSales
            item.cargoChineseName = item.jobCargoChineseName
            item.bookingAgent = item.jobBookingAgent
            item.etd = item.jobEtd
            item.customerId = item.jobCustomerId
            item.mbl = item.jobMbl
            item.vessel = item.jobVessel
            item.voyageFlight = item.jobVoyageFlight
            item.destinationPortCode = item.jobDestinationPortCode
            item.quantityActual = item.jobQuantityActual
            item.weightActual = item.jobWeightActual
          } else {
            const newItem = {}
            const job = {}
            newItem.jobUuid = job.groupKey = item.jobuuid
            newItem.jobNo = job.jobNo = item.jobNo2
            newItem.customerId = job.customerId = item.jobCustomerId
            newItem.op = job.op = item.jobOp
            newItem.sales = job.sales = item.jobSales
            newItem.etd = job.etd = item.jobEtd
            newItem.mbl = job.mbl = item.jobMbl
            newItem.customsBroker = job.customsBroker = item.jobCustomsBroker
            newItem.cargoChineseName = job.cargoChineseName = item.jobCargoChineseName
            newItem.soNo = item.jobSoNo
            newItem.customsDate = ''
            newItem.remarks = ''
            newItem.tenDigitCode = ''
            newItem.cargoEnglishName = item.cargoEnglishName
            newItem.tradeTerm = item.tradeTerm
            newItem.agentRefNo = job.agentRefNo = item.agentRefNo
            newItem.csr = job.csr = item.csr
            newItem.job = job
            list[i] = newItem
          }
        }
        if (this.appendQuery) {
          const keys = Array.from(this.rowData, p => p.uuid || p.jobUuid)
          const newRows = list.filter(p => !keys.includes(p.uuid || p.jobUuid))
          this.rowData.push(...newRows)
        } else {
          this.rowData = list
          this.pageNum = res.data.pageNum
          this.pageSize = res.data.pageSize
          this.total = Number(res.data.total)
        }
      }).finally(() => {
        loading.close()
      })
    },
    queryHandler(res) {
      const obj = res.data
      if (this.rowData == null) {
        this.rowData = []
      }
      const option = this.$refs['queryBillActualAmountCondition'].filter
      const type = this.queryType(option)
      switch (type) {
        case 0:
          this.rowData = []
          this.getFiles(obj.fileList)
          this.getJobFiles(obj.jobList)
          break
        case 1:
          if (!option.isAppend) {
            this.rowData = []
          }
          this.getJobFiles(obj.jobList, option.isAppend)
          break
        case 2:
          if (!option.isAppend) {
            this.rowData = []
          }
          this.getFiles(obj.fileList, option.isAppend)
          break
        default:
          break
      }
      this.refreshFileListEtd()
      this.$refs['queryBillActualAmountCondition'].clearCustomsNo()
      this.rowData = this.sortFileList()
    },
    refreshFileListEtd() {
      for (const file of this.rowData) {
        file.sort = new Date(file.etd).getTime()
      }
    },
    sortFileList() {
      return this.rowData.sort((a, b) => b.sort - a.sort)
    },
    getFiles(files, isAppend = false) {
      for (const file of files) {
        if (isAppend ? true : !this.fileExist(file)) {
          if (file.jobUuid != null) {
            file.op = file.jobOp
            file.sales = file.jobSales
            file.cargoChineseName = file.jobCargoChineseName
            file.bookingAgent = file.jobBookingAgent
            file.etd = file.jobEtd
            file.customerId = file.jobCustomerId
            file.mbl = file.jobMbl
            file.vessel = file.jobVessel
            file.voyageFlight = file.jobVoyageFlight
            file.destinationPortCode = file.jobDestinationPortCode
            file.quantityActual = file.jobQuantityActual
            file.weightActual = file.jobWeightActual
          }
          this.rowData.push(file)
        }
      }
    },
    fileExist(file) {
      for (const f of this.rowData) {
        if (f.uuid === file.uuid) {
          return true
        }
      }
      return false
    },
    getJobFiles(jobs, isAppend) {
      for (const item of jobs) {
        if (isAppend ? this.jobExist(item) : true) {
          const file = {}
          const job = {}
          file.jobUuid = job.groupKey = item.jobuuid
          file.jobNo = job.jobNo = item.jobNo
          file.customerId = job.customerId = item.customerId
          file.op = job.op = item.op
          file.sales = job.sales = item.sales
          file.etd = job.etd = item.etd
          file.mbl = job.mbl = item.mbl
          file.customsBroker = job.customsBroker = item.customsBroker
          file.cargoChineseName = job.cargoChineseName = item.cargoChineseName
          file.soNo = item.soNo
          file.customsDate = item.customsDate
          file.remarks = item.remarks
          file.tenDigitCode = item.tenDigitCode
          file.cargoEnglishName = item.cargoEnglishName
          file.tradeTerm = item.tradeTerm
          file.agentRefNo = job.agentRefNo = item.agentRefNo
          file.job = job
          this.rowData.push(file)
        }
      }
    },
    jobExist(item) {
      for (const j of this.rowData) {
        if (j.jobUuid === item.jobUuid) {
          return true
        }
      }
      return false
    },
    queryType(option) {
      const state = this.$refs['queryBillActualAmountCondition'].checkState
      if (option.state === 100 && state) {
        return 0
      } else if (option.state === -1 && state) {
        return 1
      } else {
        return 2
      }
    },
    addEventHandler() {
      const file = this.selectRow
      if (!file) {
        this.$message.warning(this.$t('SeaExport.NoDataSelected'))
        return
      }
      this.isFirstNewFile = true
      queryJobNoLinkFunc({ jobNo: file.jobNo }).then(res => {
        this.$nextTick(() => {
          this.job = res.data
          this.$refs.customsInfoDialog.onShow('add')
          this.addDialog.visible = true
        })
      })
    },
    editEventHandler() {
      const file = this.selectRow
      if (!file) {
        this.$message.warning(this.$t('SeaExport.NoDataSelected'))
        return
      }
      if (!file.uuid) {
        this.$message.warning(this.$t('SeaExport.PleaseANewDeclarationForm'))
        return
      }
      this.editDialog.visible = true
      this.$refs.fileDialog.onShow('edit')
    },
    batchSaveHandler() {
      if (!this.customsNoList || this.customsNoList.length === 0) {
        this.$message.warning(this.$t('SeaExport.NoDataModified'))
        return
      }
      updateFileFunc(this.customsNoList).then(res => {
        this.customsNoList = []
        this.$message.success(this.$t('SeaExport.SavedSuccessfully'))
      })
    },
    async backListEventHandler() {
      if (this.selectRow) {
        this.backList.rowList = []
        this.backList.visible = true
        if (!this.selectRow.customerId) {
          return
        }
        const fileNo = this.selectRow.fileNo
        await getFileByCustomerIdHandler(this.selectRow.customerId).then(res => {
          const list = []
          for (const item of res.data) {
            if (item.fileNo !== fileNo) {
              list.push(item)
            }
          }
          this.backList.visible = true
          this.backList.rowList = list || []
        })
      } else {
        this.$message.warning(this.$t('Message.NoDataSelected'))
      }
    },
    async gatherEventHandler() {
      if (this.selectRow) {
        this.collectInfo.rowList = []
        await getInvoiceByJobHandler(this.selectRow.jobUuid).then(res => {
          this.collectInfo.visible = true
          this.collectInfo.rowList = res.data || []
        })
      } else {
        this.$message.warning(this.$t('Message.NoDataSelected'))
      }
    },
    printEventHandler() {
      const selectedFiles = this.selectedRows
      if (selectedFiles.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectRecord'))
        return
      }
      if (!this.checkFileState(selectedFiles)) {
        this.$message.warning(this.$t('SeaExport.BatchIsInconsistentPleaseSelect'))
        return
      }
      const params = {}
      params.FILE_UUID = Array.from(selectedFiles, p => p.uuid)
      if (params.FILE_UUID.length === 0) {
        this.$message.warning(this.$t('SeaExport.NoDataAvailableForPrinting'))
        return
      }
      params.jobuuid = selectedFiles[0].jobUuid
      this.templateSelectorDialog.category = 'FileList'
      this.templateSelectorDialog.data = params
      this.templateSelectorDialog.visible = true
    },

    checkFileState(fileList) {
      let state = -1
      for (const file of fileList) {
        if (state === -1) {
          state = file.state
        }
        if (state !== file.state) {
          return false
        }
      }
      return true
    },
    batchStateEventHandler() {
      const status = this.$refs['queryBillActualAmountCondition'].getBatchFileState()
      if (status === 0) {
        this.$message.warning('状态未选择.')
        return
      }
      this.convertFileState(status)
    },
    convertFileState(status) {
      switch (status) {
        case 1:
          this.sendFile(0) // 送出
          break
        case 10:
          this.circulationFileState(status)// 接单
          break
        case 11:
          this.circulationFileState(status)// 归档
          break
        case 12:
          this.circulationFileState(status)// 退税
          break
        case 2:
          this.circulationFileState(status)// 取回
          break
        case 3:
          this.returnFileList(this.rowData) // 退还
          break
        default:
          break
      }
    },
    // 送出
    // =============================送出 ==================================
    sendFile() {
      this.sendOutDialog.visible = true
      this.sendOutDialog.sendType = 0
      this.sendOutDialog.customerType = this.sendOutDialog.sendType
      this.clearForm()
      this.setByCompanyId(this.job.bookingAgent)
      this.sendOutDialog.formData.expressNo = this.selectedFile.sendExpressNo
    },
    clearForm() {
      this.sendOutDialog.formData.receiveCompany = ''
      this.sendOutDialog.formData.receiveAddress = ''
      this.sendOutDialog.formData.receivePerson = ''
      this.sendOutDialog.formData.receiveTel = ''
      this.sendOutDialog.formData.expressNo = ''
    },
    async setByCompanyId(cmpIdx) {
      const companyCache = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', cmpIdx)
      if (!companyCache) {
        return
      }
      this.sendOutDialog.formData.receiveCompany = companyCache.chineseName
      this.sendOutDialog.formData.receiveAddress = companyCache.address
      let company = { cmpIdx: cmpIdx }
      company = new Company(company)
      let contact = null
      if (company != null) {
        const contacts = await company.getContactsBycmpIdx()
        if (contacts) {
          for (const item of contacts) {
            if (item.defaultContact) {
              contact = item
              break
            }
          }
          if (contact) {
            this.sendOutDialog.formData.receivePerson = contact.contactPerson
            this.sendOutDialog.formData.receiveTel = contact.telephone
          }
        }
      }
    },
    // =============================送出 end==================================
    // 接单 归档 退税 取回
    circulationFileState(fileState) {
      const files = this.selectedRows
      const fileStateName = this.getFileStateName(fileState)
      if (files.length === 0) {
        this.getWarningMsg(fileStateName)
        return
      }
      this.batchStateWindow.visible = true
      this.batchStateWindow.fileState = fileState
      this.batchStateWindow.files = files
      this.batchStateWindow.title = '单证' + fileStateName
      this.batchStateWindow.selectDate = new Date()
      this.batchStateWindow.labelName = fileStateName + this.$t('SeaExport.Date')
    },
    getWarningMsg(fileStateName) {
      this.$message.warning(this.$t('SeaExport.NoFilesAvailable') + fileStateName + '.')
    },
    getFileStateName(fileState) {
      if (fileState === YJD_TYPE.code) {
        return this.$t('SeaExport.Takeover')
      }
      if (fileState === YGD_TYPE.code) {
        return this.$t('SeaExport.Archive')
      }
      if (fileState === YTS_TYPE.code) {
        return this.$t('SeaExport.RefundTax')
      }
      if (fileState === YQH_TYPE.code) {
        return this.$t('SeaExport.Retrieve')
      }
      if (fileState === YTH_TYPE.code) {
        return this.$t('SeaExport.SendBack')
      }
    },
    // 退还
    returnFileList() {

    },
    clearDataHandler() {
      this.rowData = []
    },
    backStateHandler() {
      const files = this.selectedRows
      if (files.length === 0) {
        this.$message.warning(this.$t('SeaExport.FileNotSelected'))
        return
      }
      this.rollbackWindow.visible = true
      this.rollbackWindow.files = files
    },
    loadingEnd() {
      this.gridOptions.api.clearFocusedCell()
      this.fullscreenLoading.close()
      this.selectedRows = []
      this.selectRow = null
    },
    resetSearch() {
      this.$refs['queryBillActualAmountCondition'].resetSearch()
    },
    // 新增/编辑成功都走这里
    async successHandler(data) {
      this.toQuery()
    },
    async batchStateSuccessHandler(data) {
      if (data) {
        for (const file of data) {
          const index = this.rowData.findIndex(p => p.uuid === file.uuid)
          const rowData = this.rowData
          rowData[index] = file
          this.rowData = [...rowData]
        }
      }
      this.batchStateWindow.visible = false
      this.rollbackWindow.visible = false
    },
    // 海光编号变更时 记录下
    async customsNoUpdateHandler(data) {
      const index = this.customsNoList.find(p => p.uuid === data.uuid)
      if (index > -1) {
        this.customsNoList[index] = data
      } else {
        this.customsNoList.push(data)
      }
    },
    async visibleHandler() {
      this.collectInfo.visible = false
      this.backList.visible = false
      this.batchStateWindow.visible = false
      this.rollbackWindow.visible = false
    },
    onGridRowClickedEvent(event) {
      this.selectRow = event.data
      this.selectedFile = event.data
    },
    // 选中 勾选框或者其他列 都会触发[获取选中行]
    onGridCellFocused(event) {
      if (!event) return
      this.selectRow = null
      this.selectedFile = {}
      if (this.gridApi) {
        this.gridApi.forEachNode(node => {
          if (node && node.rowIndex === event.rowIndex && node.data) {
            const f = node.data
            if (f.uuid) {
              this.selectRow = f
              this.selectedData = f
            }
          }
        })
      }
    },
    xhqCustomsUnFrozenHandler() {
      const files = this.selectedRows
      if (!(files && files.length > 0)) return
      const operator = getObjectByCache(TYPE_NAMES.basic_data_User, 'userId', this.$store.getters.userId)
      const data = {
        orderOutNos: [],
        phone: operator ? operator.cell : '',
        hdUserName: operator ? operator.chineseName : '',
        opOffice: this.$store.getters.currentOfficeId
      }
      for (const file of files) {
        data.orderOutNos.push(file.cbaNumber)
      }
      const loading = getLoading4Cxt(this)
      xhqCustomsUnFrozen(data).then(res => {
        if (res.data) {
          this.$message.warning(res.data)
        } else {
          this.$message.success(this.$t('SeaExport.SendSucceeded'))
        }
      }).finally(() => loading.close())
      this.toQuery()
    },
    xhqOpenChatPage() {
      const files = this.selectedRows
      if (!(files && files.length > 0)) return
      const file = files[0]
      if (!file.xhqCustomState || file.xhqCustomState === XhqCustomState.NOT_SENT.code || file.xhqCustomState === XhqCustomState.WITHDRAWN.code) {
        this.$message.warning(this.$t('CargoMsg.OpenXhqChatTips'))
        return
      }
      const operator = getObjectByCache(TYPE_NAMES.basic_data_User, 'userId', this.$store.getters.userId)
      const data = {
        xhqAuthHdappId: this.openXHQDocumentCenter, // openXHQDocumentCenter参数配置的就是信号旗HdappId
        phone: operator ? operator.cell : '',
        jobNo: file.jobNo
      }
      const loading = getLoading4Cxt(this)
      xhqJumpChatPage(data).then(res => {
        if (res.data) {
          if (res.data.indexOf('http') === 0 || res.data.indexOf('https') === 0) {
            window.open(res.data)
          } else {
            this.$message.warning(res.data)
          }
        }
      }).finally(() => loading.close())
    }
  }
}
</script>

<style lang="scss">
  .bill-overseas-s-center-view{
    .totalLabel{
      margin-top: 6px;
      margin-left: 10px;
      margin-right: 10px;
    }
  }
</style>
